/* ÉclatDent : collection, tri, filtres et « Charger plus » (03/11/2026, 50 améliorations, points 2 à 4).
   - Tri : le <select name="sort_by"> recharge la page (tri natif Shopify, toutes pages confondues).
   - Charger plus : le lien de la page suivante est lu en arrière-plan et ses cartes ajoutées à la grille ;
     sans JS, c'est un lien ordinaire (la page suivante reste explorable).
   - Filtres : sur les cartes chargées (attributs data-type, data-besoin, data-prix) ; dans un groupe, un choix OU l'autre ;
     entre groupes, ET. Un filtre actif charge d'abord les pages restantes, pour filtrer toute la collection.
   Les boutons « Ajouter au panier » des cartes ajoutées ici sont gérés par délégation (ed-fiche.js ne lie que les cartes
   présentes au chargement). */
(() => {
  const tools = document.querySelector('[data-edc-tools]');
  const grid = document.querySelector('[data-edc-grid]');
  if (!tools || !grid) return;

  const sort = tools.querySelector('[data-edc-sort]');
  if (sort) sort.addEventListener('change', () => sort.form && sort.form.submit());

  const compte = tools.querySelector('[data-edc-compte]');
  const total = Number(tools.dataset.total || 0);
  const vide = document.querySelector('[data-edc-vide]');
  const filtres = tools.querySelector('[data-edc-filtres]');
  let more = document.querySelector('[data-edc-more]');
  const cartes = () => [...grid.querySelectorAll('[data-edc-carte]')];

  const majCompte = (visibles) => {
    if (!compte || !compte.dataset.tCompte) return;
    compte.textContent = compte.dataset.tCompte.replace('__N__', String(visibles)).replace('__T__', String(total));
  };

  // — Charger plus —
  let enCours = null;
  function chargerSuite() {
    if (!more) return Promise.resolve(false);
    if (enCours) return enCours;
    const url = more.href;
    more.setAttribute('aria-busy', 'true');
    more.classList.add('is-busy');
    enCours = fetch(url, { credentials: 'same-origin' })
      .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nouvelles = [...doc.querySelectorAll('[data-edc-grid] [data-edc-carte]')];
        nouvelles.forEach((c) => {
          c.classList.add('in');
          c.setAttribute('data-edc-ajoutee', '');
          grid.appendChild(document.importNode(c, true));
        });
        const suivant = doc.querySelector('[data-edc-more]');
        if (suivant && suivant.getAttribute('href')) {
          more.href = suivant.getAttribute('href');
          more.textContent = suivant.textContent;
        } else {
          more.remove();
          more = null;
        }
        appliquer();
        return true;
      })
      .catch(() => { if (more) location.href = url; return false; })
      .finally(() => {
        enCours = null;
        if (more) { more.removeAttribute('aria-busy'); more.classList.remove('is-busy'); }
      });
    return enCours;
  }
  if (more) more.addEventListener('click', (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    chargerSuite();
  });
  async function toutCharger() {
    let garde = 12;
    while (more && garde-- > 0) { const ok = await chargerSuite(); if (!ok) break; }
  }

  // — Filtres —
  const choix = {};
  const actif = () => Object.values(choix).some((s) => s.size > 0);
  const prixOk = (cents, v) => (v === 'p1' ? cents < 1000 : v === 'p2' ? cents >= 1000 && cents < 2000 : cents >= 2000);

  function appliquer() {
    let visibles = 0;
    cartes().forEach((c) => {
      let ok = true;
      for (const [g, set] of Object.entries(choix)) {
        if (!set.size) continue;
        const vals = [...set];
        if (g === 'type') ok = vals.includes(c.dataset.type || '');
        else if (g === 'besoin') ok = vals.some((v) => (' ' + (c.dataset.besoin || '') + ' ').includes(' ' + v + ' '));
        else if (g === 'prix') ok = vals.some((v) => prixOk(Number(c.dataset.prix || 0), v));
        if (!ok) break;
      }
      c.hidden = !ok;
      if (ok) visibles++;
    });
    const a = actif();
    document.querySelectorAll('[data-edc-reset]').forEach((b) => { if (b.closest('[data-edc-filtres]')) b.hidden = !a; });
    if (vide) vide.hidden = !(a && visibles === 0);
    majCompte(a ? visibles : cartes().length);
  }

  if (filtres) {
    filtres.hidden = false;
    filtres.querySelectorAll('[data-edc-groupe]').forEach((g) => {
      const nom = g.dataset.edcGroupe;
      choix[nom] = new Set();
      g.querySelectorAll('[data-edc-f]').forEach((b) => b.addEventListener('click', async () => {
        const on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', String(on));
        if (on) choix[nom].add(b.dataset.edcF); else choix[nom].delete(b.dataset.edcF);
        if (on && more) {
          if (compte && compte.dataset.tCharge) compte.textContent = compte.dataset.tCharge;
          await toutCharger();
        }
        appliquer();
      }));
    });
  }
  document.querySelectorAll('[data-edc-reset]').forEach((b) => b.addEventListener('click', () => {
    Object.values(choix).forEach((s) => s.clear());
    tools.querySelectorAll('[data-edc-f]').forEach((x) => x.setAttribute('aria-pressed', 'false'));
    appliquer();
  }));

  // — Ajout au panier des cartes chargées après coup —
  grid.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-edc-ajoutee] [data-add-variant]') : null;
    if (!btn || btn.disabled) return;
    const original = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.addVariant), quantity: 1 }] }),
    }).then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(() => { btn.textContent = '!'; })
      .finally(() => setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1400));
  });
})();
